import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RefListModel } from '../../../models/ref-list-model';
import { CalculationModelOverview } from '../../app-settings/models/calculation-model-overview';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class ImportService {
  /**
   * Resource for import operations
   */
  private _importResource: string;

  /**
   * Constructor
   * @param ais
   * @param httpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._importResource = this.appServiceHelper.getServiceEndpoint('pollux.import.api', 'import/v2');
  }
  /**
   * Retrieves the import configuration for a project
   * @param projectId The ID of the project
   * @returns An observable that emits the import configuration data
   */
  getImportConfigurationForProject(projectId: number): Observable<any> {
    return this.httpClient.get<any>(`${this._importResource}/importConfiguration?projectId=${projectId}`);
  }

  /**
   * Retrieves the defined calculation model templates for import
   * @param portfolioId The ID of the portfolio
   * @returns An observable that emits an array of calculation model overviews
   */
  getDefinedCalculationModelTemplatesForImport(portfolioId: number): Observable<CalculationModelOverview[]> {
    return this.httpClient.get<CalculationModelOverview[]>(`${this._importResource}/definedCalculationModelTemplatesForImport?portfolioId=${portfolioId}`);
  }

  /**
   * Retrieves the properties available for import
   * @param portfolioId The ID of the portfolio
   * @returns An observable that emits an array of property reference list models
   */
  getPropertiesForImport(portfolioId: number): Observable<RefListModel[]> {
    return this.httpClient.get<RefListModel[]>(`${this._importResource}/propertiesForImport?portfolioId=${portfolioId}`);
  }

  /**
   * Retrieves logs from the last sync with Argus (pull)
   * @param reportId
   */
  getArgusLogs(reportId: any): Observable<any> {
    return this.httpClient.get<any>(`${this._importResource}/getLogs?reportId=${reportId}`);
  }
}
